import { JobInterviewVisual } from './JobInterviewVisual'

export default JobInterviewVisual
